// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"58":"debounce-throttle","132":"plyr","377":"hammerjs","656":"sticky-js","899":"pikaday"}[chunkId] || chunkId) + ".chunk.js";
};